import { Row, Col, Input, Select, Divider, Table, Button, Modal, Tag, Space, notification, Image, Upload, Form, Spin, Alert, Progress, } from 'antd';
import { Pagination } from 'antd';
import React, { useState, useEffect } from 'react';
import { PlusOutlined, DeleteOutlined, EditOutlined, SaveOutlined, FileAddOutlined, UploadOutlined, LoadingOutlined, SyncOutlined, } from '@ant-design/icons';

import { fetchData, sendData, sendDataPut } from '../../httpRequests';
const { Search } = Input;

import * as XLSX from "xlsx"
import UploadImg from '../../components/utils/UploadImg';





const data = [

];


const form = {
    name: '',
    category_id: 1,
    description: "",
    upc: null
}

const filterCategory = {
    filterCategory_id: 0,
}

const antIcon = <SyncOutlined style={{ fontSize: 50, color: '#128780' }} spin />;

export const PharmacyCreateProduct = () => {
    const [categorys, setCategorys] = useState([]);
    const [categorysfilter, categorysFilter] = useState([]);
    const [isModalVisibleCreateProduct, setIsModalVisibleCreateProduct] = useState(false);
    const [isModalVisibleCreateProductList, setIsModalVisibleCreateProductList] = useState(false);
    const [products, setProducts] = useState([]);
    const [filteredProducts, setFilteredProducts] = useState([]);
    const [formValues, setFormValues] = useState(form)
    const [formValuesCategories, setFormValuesCategories] = useState(filterCategory)
    const [nameFile, setNameFile] = useState('')
    const [fileSeleted, setFileSeleted] = useState('')
    const [img, setImg] = useState(null)
    const [imgEdit, setImgEdit] = useState('')
    const [openModalEditar, setOpenModalEditar] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    // const [searchFilterCategory, setSearchFilterCategory] = useState(filterCategory);
    const [initPorcent, setInitPorcent] = useState(0);
    const [tbLoading, setTbLoading] = useState(false)
    const [productQuantity, setProductQuantity] = useState(0)

    const [initial, seIinitial] = useState(0)
    const [limit, setLimit] = useState(10)
    const [selectCurrent, setSelectCurrent] = useState(1)
    const [selectCategorie, setSelectCategorie] = useState(0)
    const [selectImage, setSelectImage] = useState(0)

    const [text, setText] = useState('')


    const { name, category_id, description, upc } = formValues
    const { filterCategory_id } = formValuesCategories
    // current

    const getProducts = () => {
        setTbLoading(true)
        const url = `/products/getProductsWithCategoryWhitowImg/${limit}/${initial}/${selectCategorie}/${selectImage}`;
        fetchData(url).then((response) => {
            if (Object.keys(response).length > 0) {
                const products = response['products'];
                setProducts(products)
                setFilteredProducts(products)
                setProductQuantity(response.productQuantity)
                console.log(productQuantity, "ddd")
            }
            setTbLoading(false)
        })
    }
    const getCategorys = () => {
        const url = '/categories/getCategories';
        fetchData(url).then((response) => {
            if (Object.keys(response).length > 0) {
                const categories = response['category'];
                setCategorys(categories)
            }
        })
    }
    const getCategorysfilter = () => {
        const url = '/categories/getCategories';
        fetchData(url).then((response) => {
            if (Object.keys(response).length > 0) {
                const categories = response['category'];
                let allCategory = categories
                allCategory.unshift({ id: 0, name: 'All' })
                categorysFilter(allCategory)
            }
        })
    }
    useEffect(() => {
        getProducts()
        getCategorys()
        getCategorysfilter()
    }, [])



    const clearForm = () => {
        setFormValues(form)
        // ponr que limpie el file
    }

    const cancelarModales = () => {
        setIsModalVisibleCreateProduct(false)
        setIsModalVisibleCreateProductList(false)
        setOpenModalEditar(false)
    }

    const deleteModal = () => {
        // setIsModalVisible(true);
    };

    const showModalCreateProduct = (id) => {
        setIsModalVisibleCreateProduct(true);
    };

    const showModalCreateProductList = (id) => {
        setIsModalVisibleCreateProductList(true);
    };

    // close modal
    const handleCancel = () => {
        setIsModalVisibleCreateProduct(false)
        setIsModalVisibleCreateProductList(false);
        setIsModalVisibleCreateProduct(false)
        setIsModalVisibleCreateProductList(false)
        setOpenModalEditar(false)
        setFormValues(form)
        setImg(null)
        clearForm()


    };
    // buscador
    const onSearch = (value) => {
        // setProducts([])
        // setFilteredProducts([])
        seIinitial(0)
        setLimit(10)
        setSelectCurrent(1)
        setSelectCategorie(0)
        setSelectImage(0)

        setFormValues({
            ...formValues,
            category_id: 0

        })
        setSelectImage(0)

        let texto = value.target.value
        setText(texto)


        const url = `/products/getProductsSearch/${limit}/${0}`;
        if (texto != '') {
            sendData(url, { text: texto.trim() }).then((response) => {

                // const products = response['products'];
                setProducts(response.product)
                setFilteredProducts(response.product)

                setProductQuantity(response.productQuantity)
            })
        } else {
            getProducts()
        }
    }

    const handleInputChange = ({ target }) => {
        setFormValues({
            ...formValues,
            [target.name]: target.value
        });
    }
    const handleInputChangeSelect = (e) => {
        console.log("llego", e)
        setFormValues({
            ...formValues,
            category_id: e

        })
    }

    // file
    const saveProductFile = async () => {
        // inti file
        setIsLoading(true)
        const promise = new Promise((resolve, reject) => {
            const fileReader = new FileReader();

            fileReader.readAsArrayBuffer(fileSeleted);

            fileReader.onload = (e) => {
                const bufferArray = e.target.result;

                const wb = XLSX.read(bufferArray, { type: "buffer" });

                const wsname = wb.SheetNames[0]


                const ws = wb.Sheets[wsname]

                const data = XLSX.utils.sheet_to_json(ws);

                resolve(data)
            };

            fileReader.onerror = (error) => {
                reject(error)
                setIsLoading(false)
            };
        });

        promise.then(async (d) => {

            let init = 0
            let fin = 0
            let entrada = []
            let total = Math.floor(d.length / 100)

            for (let i = 0; i <= total; i++) {
                init = i * 100
                fin = fin + 100
                entrada.push(d.slice(init, fin))
            }
            for (let i in entrada) {
                let response = await sendData(`/products/createProductwithFile`, entrada[i])
                if (response.ok) {
                    setInitPorcent(Math.round((i / entrada.length) * 100))
                    if (i == entrada.length - 1) {
                        setIsLoading(false)
                        getProducts()
                        openNotificationWithIcon('success', 'product added successfully')
                        setIsModalVisibleCreateProductList(false)
                    }
                } else {
                    openNotificationWithIcon('warning', 'This file does not meet the requirements.')
                    openNotificationWithIcon('warning', 'an error has occurred contact the administrator.')
                }
            }
            setInitPorcent(0)


            // if (response.ok) {
            //     setIsLoading(false)
            //     console.log(response.products.length)
            //     if (response.products.length != 0 || response.productCategoriAll.length != 0) {
            //         let sum = response.products.length + response.productCategoriAll.length
            //         openNotificationWithIcon('success', 'product added successfully')
            //         openNotificationWithIcon('success', `${sum} product added successfully`)
            //         getProducts()
            //         setIsModalVisibleCreateProductList(false)
            //     } else {
            //         openNotificationWithIcon('success', 'there are no products to add')
            //         setIsModalVisibleCreateProductList(false)
            //     }


            // }
        })

    }

    const readExcel = (file) => {
        if (file == '' || file == null || file == undefined) {
            console.log('no hay nada selecionado file')
            setNameFile('')
            setFileSeleted('')
        } else {
            console.log(file)
            setNameFile(file.name)
            setFileSeleted(file)
        }
    }
    // notificaiones o errores
    const openNotificationWithIcon = (type, mensaje) => {
        notification[type]({
            description: mensaje
        });
    };

    const columns = [
        {
            title: '',
            render: ({ img }) => (
                <div
                    style={{
                        width: 40
                    }}
                >
                    <Image src={img ? img : "http://openmart.online/frontend/imgs/no_image.png?v=1"} />
                </div>
            )
        },
        {
            title: 'UPC',
            dataIndex: 'upc',
            key: 'upc',
        },
        {
            title: 'name',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: 'Category',
            dataIndex: 'category_name',
            key: 'nameCategory',
        },
        {
            title: 'Action',
            render: ({ id, name, nameCategory, upc, description, category_id, img }) => (
                <div style={{ display: 'flex' }} onClick={() => showModalEditar(id, name, nameCategory, upc, description, category_id, img)}>
                    <span style={{ margin: 10, cursor: 'pointer' }}>
                        <EditOutlined style={{ fontSize: '25px', color: '#128780' }} />
                    </span>

                    <span style={{ margin: 10, cursor: 'pointer' }} onClick={deleteModal} >
                        <DeleteOutlined style={{ fontSize: '25px', color: 'red' }} />
                    </span>
                </div>

            )
        },

    ];

    // img file
    const handleFile = async (id) => {

        let cloudurl = (window.location.hostname.includes('localhost'))
            ? `http://localhost:3003/api/products/updateProductPhoto/${id}`
            : `https://coopharma-api-zd5is.ondigitalocean.app/api/products/updateProductPhoto/${id}`

        let file = img
        const formData = new FormData();
        formData.append('image', file);
        // console.log(id, "response del editar", cloudurl)
        try {
            const resp = await fetch(cloudurl, {
                method: 'post',
                body: formData
            });

            if (resp.ok) {
                const cloudResp = await resp.json();
                console.log(cloudResp, 'response')
                getProducts()
                setImg(null)
                getProducts()
                setIsLoading(false)
            }
        } catch (error) {
            console.log(error, "error")
        }
    }
    const props = {
        listType: 'picture',
        beforeUpload(file) {
            setImg(file)
        }
    }

    // save
    const SaveProduct = async () => {
        setText('')
        seIinitial(0)
        setLimit(10)
        setSelectCurrent(1)
        setSelectCategorie(0)
        setSelectImage(0)
        setIsLoading(true)
        // console.log(img, 'del crear, editar')
        const url = '/products/createProduct';
        sendDataPut(url, formValues).then((response) => {
            if (response.ok) {
                openNotificationWithIcon('success', 'product created successfully')
                setIsModalVisibleCreateProduct(false)
                if (img != null) {
                    handleFile(response.product.id)
                }
                getProducts()
                setIsLoading(false)
                clearForm()
            } else {
                // console.log("producto seve", response.mensaje)
                openNotificationWithIcon('error', response.mensaje)
                setIsLoading(false)
            }
        })


    }

    // editar
    const showModalEditar = (id, name, nameCategory, upc, description, category_id, img) => {
        console.log(id, name, nameCategory, upc, description)
        setOpenModalEditar(true)
        const EditForm = {
            name,
            upc,
            description: description == null ? '' : description,
            category_id: category_id,
            idEdit: id
        }
        // console.log(EditForm)
        setImgEdit(img)

        setFormValues(EditForm)

    }

    const SaveProductEdit = () => {
        setText('')
        seIinitial(0)
        setLimit(10)
        setSelectCurrent(1)
        setSelectCategorie(0)
        setSelectImage(0)

        setIsLoading(true)
        const { idEdit, ...data } = formValues
        setIsLoading(true)
        const url = `/products/updateProduct/${idEdit}`;
        sendDataPut(url, data).then((response) => {
            if (response.ok) {
                openNotificationWithIcon('success', 'product updated successfully')
                setIsLoading(false)
                setOpenModalEditar(false)
                if (img != null) {
                    handleFile(response.id)
                } else {
                    getProducts()
                }
            } else {
                // console.log('false')
                setIsLoading(false)
            }
        })
    }

    // filtrar por categoria
    const handleFilter = async (e) => {
        setText('')
        seIinitial(0)
        setSelectCurrent(1)
        setSelectCategorie(e)
        // const filteredProducts = products.filter((product) => {
        //     return product.categoryId == e

        // });

        // setFilteredProducts(filteredProducts);
        setFormValuesCategories({
            ...formValues,
            filterCategory_id: e

        })


        setTbLoading(false)
        const url = `/products/getProductsWithCategoryWhitowImg/${limit}/${initial}/${e}/${selectImage}`;
        fetchData(url).then((response) => {
            if (Object.keys(response).length > 0) {
                const products = response['products'];
                setProducts(products)
                setFilteredProducts(products)
                setProductQuantity(response.productQuantity)
                console.log(productQuantity, "ddd")
            }
            setTbLoading(false)
        })
    }

    // filtrar pr img
    const searchImgProduct = (e) => {
        setText('')
        setSelectCurrent(1)
        setSelectImage(e)
        setTbLoading(true)
        const url = `/products/getProductsWithCategoryWhitowImg/${limit}/${initial}/${selectCategorie}/${e}`;
        fetchData(url).then((response) => {
            if (Object.keys(response).length > 0) {
                const products = response['products'];
                setProducts(products)
                setFilteredProducts(products)
                setProductQuantity(response.productQuantity)
                console.log(productQuantity, "ddd")
            }
            setTbLoading(false)
        })
        // if (e == 1 || e == '1') {
        //     getProductsWitHoutImg()
        // } else {
        //     getProducts()
        // }
    }
    const getProductsWitHoutImg = () => {
        const url = '/products/getProductWithout';
        fetchData(url).then((response) => {
            if (Object.keys(response).length > 0) {
                const products = response['products'];
                setProducts(products)
                setFilteredProducts(products)

            }
        })
    }

    const handlePagination = async (value, value2) => {

        // seIinitial( value * 10)
        console.log(value, value2)
        setLimit(value2)
        setSelectCurrent(value)
        let takedValue;
        if (value == 1) {
            takedValue = 0
            seIinitial(0)
        } else {
            takedValue = 10 * value - 10
            seIinitial(takedValue)

        }

        setTbLoading(true)
        const url = `/products/getProductsWithCategoryWhitowImg/${value2}/${takedValue}/${selectCategorie}/${selectImage}`;
        fetchData(url).then((response) => {
            if (Object.keys(response).length > 0) {
                const products = response['products'];
                setProducts(products)
                setFilteredProducts(products)
                setProductQuantity(response.productQuantity)
            }
            setTbLoading(false)
        })
        // getProducts()
    }

    const handlePa = async (value, value2) => {
        setLimit(value.pageSize)
        setSelectCurrent(value.current)

        let takedValue;
        if (value.current == 1) {
            takedValue = 0
            seIinitial(0)
        } else {
            takedValue = 10 * value.current - 10
            console.log(takedValue)
            seIinitial(takedValue)
        }

        if (text == '') {
            setTbLoading(true)
            const url = `/products/getProductsWithCategoryWhitowImg/${value.pageSize}/${takedValue}/${selectCategorie}/${selectImage}`;
            fetchData(url).then((response) => {
                if (Object.keys(response).length > 0) {
                    const products = response['products'];
                    setProducts(products)
                    setFilteredProducts(products)
                    setProductQuantity(response.productQuantity)
                }
                setTbLoading(false)
            })
        } else {
            const url = `/products/getProductsSearch/${value.pageSize}/${takedValue}`;
            sendData(url, { text }).then((response) => {
                console.log(response.product)

                setProducts(response.product)
                setFilteredProducts(response.product)
                console.log(products)
                setProductQuantity(response.productQuantity)
            })
        }


        // seIinitial( value * 10)
        // console.log( value, pageSize)

    }


    return (
        <div>
            <Row gutter={24}>
                <Col span={6}>
                    <Input
                        size='large'
                        type='text'
                        name="texto"
                        value={text}
                        onChange={onSearch}
                        placeholder='Search Product'
                    />
                </Col>
                <Col span={5}>
                    <Select style={{ width: '100%' }} defaultValue={filterCategory_id} size='large' onChange={handleFilter} name="category_id" value={filterCategory_id} >
                        {categorysfilter.map((c) => (
                            <Select.Option key={c.id} value={c.id}  >
                                {c.name}
                            </Select.Option>
                        ))
                        }
                    </Select>
                </Col>
                <Col span={4}>
                    <Select style={{ width: '100%' }} defaultValue={selectImage} size='large' onChange={searchImgProduct} name="" >
                        <Select.Option value={1}>
                            products without image
                        </Select.Option>
                        <Select.Option value={0}>
                            All
                        </Select.Option>
                    </Select>
                </Col>
                <Col span={4}>
                    <Button
                        onClick={showModalCreateProduct}
                        type='primary'
                        size='large'
                        style={{ backgroundColor: '#128780', width: '100%', borderRadius: 5 }}
                    >
                        {/* <PlusOutlined /> */}
                        Create product
                    </Button>
                </Col>
                <Col span={5}>
                    <Button
                        onClick={showModalCreateProductList}
                        type='primary'
                        size='large'
                        style={{ backgroundColor: '#128780', width: '100%', borderRadius: 5 }}
                    >
                        {/* <PlusOutlined /> */}
                        Create product list
                    </Button>
                </Col>


            </Row>
            <Divider />

            {/* modal crear productos */}
            <Modal centered
                width={600}
                title="Add Product"
                visible={isModalVisibleCreateProduct}
                onCancel={handleCancel}
                footer={null}
                closable={true}
            >


                <Row gutter={24}>
                    <Col span={24} className='formMarginInput'>
                        <label htmlFor=""><span style={{ color: 'red' }}>*</span> UPC</label>
                        <Input
                            size='large'
                            type='number'
                            name="upc"
                            value={upc}
                            onChange={handleInputChange}
                        />
                    </Col>
                    <Col span={24} className='formMarginInput'>
                        <label htmlFor=""><span style={{ color: 'red' }}>*</span>  Name</label>
                        <Input
                            size='large'
                            name="name"
                            value={name}
                            onChange={handleInputChange}
                        />
                    </Col>

                    <Col span={24} className='formMarginInput' >
                        <label htmlFor=""><span style={{ color: 'red' }}>* </span>Category</label>
                        <Select style={{ width: '100%' }} defaultValue={category_id} size='large' onChange={handleInputChangeSelect} name="category_id" value={category_id} >
                            {categorys.map((c) => (
                                <Select.Option key={c.id} value={c.id}  >
                                    {c.name}
                                </Select.Option>
                            ))
                            }
                        </Select>

                    </Col>
                    <Col span={24} className='formMarginInput'>
                        <label htmlFor=""><span style={{ color: 'red' }}> </span>Description</label>
                        <textarea id="w3review"
                            rows="4" cols="70"
                            name="description"
                            value={description}
                            onChange={handleInputChange}
                            style={{ width: '100%' }}
                        />
                    </Col>
                    <Col span={24} className='formMarginInput'>
                        <label htmlFor="">Image </label>
                        <Upload {...props} maxCount={1} >
                            <Button icon={<UploadOutlined />}>Upload</Button>
                        </Upload>,
                    </Col>
                    {/* <Col span={24} className='formMarginInput'>
                        <label htmlFor="">Image </label>
                        <UploadImg />
                    </Col> */}
                    {
                        isLoading == true ? (<Col span={24} style={{ textAlign: 'center', padding: '10px' }} >
                            <Spin tip="Please Wait....." indicator={antIcon}>
                            </Spin>,
                        </Col>)
                            : (<></>)
                    }


                    <Col span={24}>
                        <Button
                            onClick={SaveProduct}
                            type='primary'
                            size='large'
                            style={{ backgroundColor: '#128780', width: '100%', borderRadius: 5 }}
                            disabled={name == '' || upc == null || upc == ''}

                        >
                            <SaveOutlined />
                            Save
                        </Button>
                    </Col>
                </Row>
            </Modal>
            {/* modal crear producto por file */}
            <Modal title="Add Product" visible={isModalVisibleCreateProductList}
                onCancel={handleCancel}
                footer={[
                    <Button key='back' disabled={fileSeleted == ''} onClick={saveProductFile} type='primary'
                        size='large'
                        style={{ backgroundColor: '#128780', width: '100%', borderRadius: 5 }}>
                        <SaveOutlined />
                        save File</Button>
                ]}
            >
                <div className='bordereFile'>
                    <div className='file-select'>
                        {/* <div className='close-drap'>
					<CloseCircleOutlined  style={{ fontSize: '20px',color: 'red' }}/>
					</div> */}
                        <div className='drag'>
                            <div>
                                <div style={{ textAlign: 'center' }}>
                                    <FileAddOutlined style={{ fontSize: '32px', color: 'white' }} />
                                </div>
                                <div style={{ textAlign: 'center' }}>
                                    <b style={{ fornSize: '17px', color: 'white' }}>Add File</b>
                                </div>
                                <p style={{ color: 'white' }}>or drag and drop</p>
                            </div>
                        </div>
                        <input type="file" onChange={(e) => {
                            const file = e.target.files[0]
                            readExcel(file)
                        }} />
                    </div>
                </div>

                {
                    nameFile == '' ? (<small style={{ color: 'red' }}>No file selected</small>)
                        : (<small><span>{nameFile}</span></small>)
                }
                {
                    isLoading == true ? (<Col span={24} style={{ textAlign: 'center', padding: '10px' }} >
                        <Spin tip="Please Wait This may take a while...." indicator={antIcon}>
                        </Spin>,
                        <Progress
                            strokeColor={{
                                '0%': '#108ee9',
                                '100%': '#87d068',
                            }}
                            percent={initPorcent}
                        />

                    </Col>)
                        : (<></>)
                }

            </Modal>
            {/* Modal editar productos */}
            <Modal title="Edit Product"
                visible={openModalEditar}
                width={600}
                onCancel={handleCancel}
                footer={null}
                closable={true}
            >

                <Row gutter={24}>
                    <Col span={24} className='formMarginInput'>
                        <label htmlFor=""><span style={{ color: 'red' }}>*</span> UPC</label>
                        <Input
                            size='large'
                            type='number'
                            name="upc"
                            value={upc}
                            onChange={handleInputChange}
                        />
                    </Col>
                    <Col span={24} className='formMarginInput'>
                        <label htmlFor=""><span style={{ color: 'red' }}>*</span>  Name</label>
                        <Input
                            size='large'
                            name="name"
                            value={name}
                            onChange={handleInputChange}
                        />
                    </Col>
                    {/* <Col span={24} className='formMarginInput' >
                        <label htmlFor=""><span style={{ color: 'red' }}>* </span>Category</label>
                        <Select style={{ width: '100%' }} defaultValue={category_id} size='large'
                            onChange={handleInputChangeSelect} name="category_id" value={category_id} >
                            {categorys.map((c) => (
                                <Select.Option key={c.id} value={c.id}  >
                                    {c.name}
                                </Select.Option>
                            ))
                            }
                        </Select>

                    </Col> */}
                    <Col span={24} className='formMarginInput'>
                        <label htmlFor=""><span style={{ color: 'red' }}> </span>Description</label>
                        <textarea
                            id="w3review"
                            rows="4" cols="70"
                            name="description"
                            value={description}
                            onChange={handleInputChange}
                            style={{ width: '100%' }}
                        />
                    </Col>

                    <Col span={24} className='formMarginInput'>
                        <label htmlFor="">Image </label>
                        <Upload {...props} maxCount={1} >
                            <Button icon={<UploadOutlined />}>Upload</Button>
                        </Upload>
                    </Col>
                    <Col span={24} className='formMarginInput' >
                        <label htmlFor=""><span style={{ color: 'red' }}>* </span>Category</label>
                        <Select style={{ width: '100%' }} defaultValue={category_id} size='large' onChange={handleInputChangeSelect} name="category_id" value={category_id} >
                            {categorys.map((c) => (
                                <Select.Option key={c.id} value={c.id}  >
                                    {c.name}
                                </Select.Option>
                            ))
                            }
                        </Select>

                    </Col>
                    <Col span={24} className='formMarginInput'>
                        <Image src={imgEdit} style={{ width: '100px' }} />
                    </Col>
                    {
                        isLoading == true ? (<Col span={24} style={{ textAlign: 'center', padding: '10px' }} >
                            <Spin tip="Please Wait....." indicator={antIcon}>
                            </Spin>,
                        </Col>)
                            : (<></>)
                    }
                    <Col span={24}>
                        <Button
                            onClick={SaveProductEdit}
                            type='primary'
                            size='large'
                            style={{ backgroundColor: '#128780', width: '100%', borderRadius: 5 }}
                            disabled={name == '' || upc == null || upc == ''}
                        >
                            <SaveOutlined />
                            Save
                        </Button>
                    </Col>

                </Row>

            </Modal>


            <Table columns={columns} dataSource={filteredProducts} rowKey={(item) => item.id} loading={tbLoading}
                pagination={{ pageSize: limit, total: productQuantity, current: selectCurrent }} onChange={handlePa}
            />






            {/* <div style={{ textAlign: 'center', margin: 10 }}>

                <Pagination current={selectCurrent} total={productQuantity} onChange={handlePagination} simple={false} />
            </div> */}

            {/*  pagination={{ position: ['none'] }} */}


        </div>

    )
}